import React from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { fetchedSearchedTickets } from "../TicketAction";

export const SearchBox = () => {
  const dispatch = useDispatch();

  const strHandler = (e) => {
    // FilterStr(e.target.value);
    console.log(e.target.value);
    dispatch(fetchedSearchedTickets(e.target.value));
  };

  return (
    <>
      <Form md="6">
        <Form.Label>Search</Form.Label>
        <Form.Control
          type="search"
          placeholder="searc..h..."
          onChange={strHandler}
        />
      </Form>
    </>
  );
};
